import { useMemo, useState } from 'react';
import { Address, product } from '../../../Net/NetProtocol';
import CommonPop from '../../CommonPop';
import style from './index.module.scss';
import classnames from 'classnames/bind';
import MdAddress from '../MdAddress';
import TxtValues from '../../../components/TxtValues';
const className = classnames.bind(style);

interface PropsTarget {
    item:product,
    closeFunc:()=>void
}
const orderstatus = [
    "Unpaid",
    "Unpaid",
    "Approved",
    "Voided",
    "Paid",
    "Unauthorized",
    "Shipped"
]
const OrderDetails = (props: PropsTarget)=>{
    const [showMdAddress, SetMdAddress] = useState(false);
    const {item, closeFunc} = props;
    const userad:Address = useMemo(()=>{return item.address}, [item.address]);
    const getstatus = (status:number)=>{
        return orderstatus[status];
    }
    const datetimetostr = (timed:number)=>{
        let timestr = "";
        let timedts = new Date(timed);
        timestr = timedts.toLocaleDateString() + " " + timedts.toLocaleTimeString();
        return timestr;
    }

    const CheckTrack = ()=>{
        const gourl = "https://track.yw56.com.cn/en/querydel?nums="+item.trackingnum;
        window.open(gourl);
    }

    const openMdAddress = ()=>{
        SetMdAddress(true);
    }

    const MdFinish = (address:Address)=>{
        item.address = address;
        SetMdAddress(false);
    }

    const CloseMdAddress = ()=>{
        SetMdAddress(false);
    }

    return(
        <>
        <CommonPop closeWindown={closeFunc} titlestr={"Order Details"}>
            <div className={className('contentbox')}>
                <div className={className('addressinfo')}>
                    <TxtValues title='OrderId: ' values={item.captureid || item.orderid}/>
                    <TxtValues title='Payment: ' values={"$" + item.price}/>
                    <TxtValues title='State: ' values={getstatus(item.state)}/>
                    <TxtValues title='Date: ' values={datetimetostr(item.timed)}/>
                </div>
                <div className={className('addressinfo')}>
                    <div className={className('title')}>
                    Address:
                    </div>
                    <TxtValues title='fullname: ' values={userad?.fullname}/>
                    <TxtValues title='phone: ' values={userad?userad.areacode+userad.phonenum:""}/>
                    <TxtValues title='country: ' values={userad?.country}/>
                    <TxtValues title='address: ' values={userad?.address}/>
                    <TxtValues title='postcodes: ' values={userad?.postcodes}/>
                    { item.state !== 6 && <button className={className('modifybutton')} onClick={openMdAddress}>Modify Address</button> }
                </div>
                    { item.state === 6 &&
                        <div className={className('addressinfo')}>
                            <TxtValues title='Track: ' values={item.trackingnum}/>
                            <button className={className('modifybutton')} onClick={CheckTrack} >Logistics Information</button>
                        </div>
                    }
            </div>
        </CommonPop>
        {showMdAddress && <MdAddress orderid={item.timed} address={userad} modifyFinish={MdFinish} closeFunc={CloseMdAddress}></MdAddress>}
        </>
    )
}

export default OrderDetails;